
















































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbProgress, mdbBtn, mdbTooltip } from '@folky-tools/mdbvue';
import { VueGoodTable } from '@folky-tools/vue-good-table';
import { usersService, axiosService, authorizationManagerService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { BusinessOrder } from '@/models/orders/business-order';

@Component({
    components: {
        mdbProgress,
        mdbBtn,
        mdbTooltip,
        VueGoodTable,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessOrdersListView extends Vue {
    private rows: BusinessOrder[] = [];
    private columns: any[] = [];
    private totalRecords: number = 0;
    private actualUserCanReadMultipleBusinesses: boolean = false;
    private isLoading: boolean = false;
    private ordersPerPage: number = 20;

    private serverParams: any = {
        columnFilters: {},
        sort: [
            {
                field: 'created',
                type: 'desc'
            }
        ],
        page: 1,
        perPage: this.ordersPerPage
    };

    private async beforeMount(): Promise<void> {
        this.actualUserCanReadMultipleBusinesses = authorizationManagerService.isAdmin || authorizationManagerService.canReadMultipleBusinesses;

        await this.setColumns(this.actualUserCanReadMultipleBusinesses);
        await this.loadItems();
    }

    private async mounted(): Promise<void> {
        if (this.$route.query.businessName) {
            this.$root.$emit('change-active-page', 'views.orders.businessOrdersListView.titleSingleBusiness', this.$route.query.businessName.toString());
        } else {
            this.$root.$emit('change-active-page', 'views.orders.businessOrdersListView.title');
        }

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.BusinessOrders,
                scope: UserActionScopeType.List
            })
        );
    }

    private async loadItems(): Promise<void> {
        this.isLoading = true;

        const response: any = await axiosService.instance.get('orders/businesses/organization/query', {
            params: this.getQueryParams(this.serverParams.sort, this.serverParams.page, this.serverParams.perPage)
        });

        this.rows = [];

        this.totalRecords = response.data.count;
        response.data.items.forEach((item: any) => {
            this.rows.push(new BusinessOrder(item));
        });

        this.isLoading = false;
    }

    private getQueryParams(sortOrder: any, currentPage: number, perPage: number): any {
        return {
            $skip: (currentPage - 1) * perPage,
            $top: perPage,
            $orderby: this.getQueryOrderFromColumn(sortOrder),
            $filter: this.getQueryFilterFromColumns()
        };
    }

    private getQueryFilterFromColumns(): string | null {
        let queryFilter = '';
        const logicalOperatorBetweenFilters = ' and ';

        for (const key of Object.keys(this.serverParams.columnFilters)) {
            if (this.serverParams.columnFilters[key]) {
                if (key === 'businessTradeName') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(businessTradeName, '${this.serverParams.columnFilters[key].replace('\'', '\'\'')}')`;
                }

                if (key === 'buyerEmail') {
                    queryFilter += `${logicalOperatorBetweenFilters}contains(buyerEmail, '${this.serverParams.columnFilters[key]}')`;
                }
            }
        }

        return queryFilter === '' ? null : queryFilter.substring(logicalOperatorBetweenFilters.length);
    }

    private getQueryOrderFromColumn(sortOrder: any): string | null {
        if (sortOrder && sortOrder.length === 1) {
            if (sortOrder[0].field === 'created') {
                return `createdUtc ${sortOrder[0].type}`;
            } else {
                return `${sortOrder[0].field} ${sortOrder[0].type}`;
            }
        } else {
            return null;
        }
    }

    private setColumns(showBusinessTradeNameColumn: boolean): void {
        this.columns = [
            { field: 'id', type: 'text', sortable: false },
            { field: 'applicationName', type: 'text', sortable: false },
            { field: 'code', sortable: false, type: 'text' },
            {
                field: 'created',
                sortable: true,
                type: 'text'
            }
        ];

        if (showBusinessTradeNameColumn) {
            this.columns.push({
                field: 'businessTradeName',
                sortable: false,
                type: 'text',
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('common.placeholders.searchBySeller'),
                    filterValue: ''
                }
            });
        }

        this.columns.push(
            {
                field: 'buyerEmail',
                sortable: false,
                type: 'text',
                filterOptions: {
                    enabled: true,
                    placeholder: this.$t('views.orders.businessOrdersListView.searchByBuyer'),
                    filterValue: ''
                }
            },
            { field: 'deliveryInfoDetails', sortable: false, type: 'text' },
            { field: 'paymentMethod', sortable: false, type: 'text' },
            { field: 'totalPrice', sortable: false, type: 'number' }
        );
    }

    private async onPageChange(params: any): Promise<void> {
        this.updateParams({ page: params.currentPage });
        await this.loadItems();
    }

    private async onSortChange(params: any): Promise<void> {
        this.updateParams({
            sort: [
                {
                    type: params[0].type,
                    field: params[0].field
                }
            ]
        });
        await this.loadItems();
    }

    private async onColumnFilter(params: any): Promise<void> {
        this.serverParams.page = 1;
        this.updateParams(params);
        await this.loadItems();
    }

    private async onPerPageChange(params: any): Promise<void> {
        this.updateParams({ perPage: params.currentPerPage });
        await this.loadItems();
    }

    private updateParams(newProps: any): void {
        this.serverParams = { ...this.serverParams, ...newProps };
    }
}
